import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { useAuth } from "../../services/AuthContext";
import { getAdminCourses } from "../../services/admin";
import AdminReloadOverlay from "./AdminReloadOverlay";

const resolveThumb = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith("/")) return url;
  return `/${url}`;
};

export default function AdminContentPage() {
  const { getIdToken } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        setError("");
        const token = await getIdToken();
        const data = await getAdminCourses(token);
        if (!cancelled) setCourses(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Não foi possível carregar os cursos.");
          setCourses([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [getIdToken]);

  return (
    <div className="admin-page">
      <AdminReloadOverlay visible={loading} message="Atualizando cursos..." />
      <div className="admin-page-header">
        <h1 className="admin-title">
          <BookOpen size={30} className="admin-title-icon" />
          Conteúdo
        </h1>
        <p className="admin-subtitle">
          Cursos do site. Abra um curso para ver seções, aulas e editar o conteúdo.
        </p>
      </div>

      {error && <div className="admin-error">{error}</div>}
      {!loading && courses.length === 0 && (
        <div className="admin-empty">Nenhum curso encontrado.</div>
      )}

      <div className="admin-grid">
        {courses.map((course) => {
          const thumb = resolveThumb(course.thumbnail_url);
          return (
            <Link
              key={course.code || course.id}
              to={`/admin/content/${course.code}`}
              className="admin-card admin-card-link"
            >
              {thumb && <img className="admin-thumb" src={thumb} alt="" />}
              <h3 className="admin-card-title">{course.title || course.code}</h3>
              <p className="admin-card-meta">{course.instructor || "Sem professor"}</p>
              <p className="admin-card-meta">{course.category || "Sem categoria"}</p>
              <div>
                <span
                  className={`admin-status ${
                    course.availability === "paid" ? "admin-status-paid" : "admin-status-free"
                  }`}
                >
                  {course.availability === "paid" ? "Premium" : "Gratuito"}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
